export const PIE_COLORS = [
  '#4286f5',
  '#73c18a',
  '#fbd04d',
  '#e78070',
  '#48bdc6',
  '#ff6a04',
  '#34a754',
  '#fcbc05',
  '#ea4234',
];

export const getPieCellColor = (index: number): string =>
  PIE_COLORS[index % PIE_COLORS.length];
